// import React, { Suspence, lazy } from 'react';
import './App.css';

import Hero from './sections/hero'
import About from './sections/about'
import Projects from './sections/projects'
import Work from './sections/work'
import Contact from './sections/contact'

// import Loader from './sections/loader'

// const Hero = lazy(() => import('./sections/hero'))
// const About = lazy(() => import('./sections/about'))
// const Projects = lazy(() => import('./sections/projects'))
// const Work = lazy(() => import('./sections/work'))
// const Contact = lazy(() => import('./sections/contact'))

// const Loader = lazy(() => import('./sections/loader'))

function App() {
  return (
    <>
      <Hero />
      <About />
      <Projects />
      <Work />
      <Contact />

      {/* <Loader /> */}
    </>
  );
}

export default App;
